import axios from "axios";
import { ReactNode, createContext, useState } from "react";
import { ApiEndpoint } from "./utils";

interface appChildren {
  children: ReactNode;
}
export interface ctxDefinition {
  examType?: number;
  setExamType: (id: number) => void;
  loggedIn: boolean;
  setLoggedIn: (isloggedIn: boolean) => void;
  userData: any;
  setUserData: (data: any) => void;
  examStarted: boolean;
  setExamStarted: (isStarted: boolean) => void;
  examStartTime: number;
  setExamStartTime: (time: number) => void;
  setExamSectionStartTime: (time: number) => void;
  config: any;
  setConfig: (data: any) => void;
}

const AppDataContext = createContext<ctxDefinition | null>(null);

const AppCtxProvider = ({ children }: appChildren) => {
  const [examType, setExamType] = useState(0);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [examStarted, setExamStarted] = useState(false);
  const [examStartTime, setExamStartTime] = useState(0);
  const [config, setConfig] = useState(null);
  
  const setExamSectionStartTime = async (timestamp: number) => {
    setExamStartTime(timestamp);
    setExamStarted(true);
    const temp: any = Object.assign({}, userData);
    temp.sectionStartTime = timestamp;
    temp.examStarted = true;
    setUserData(temp);

    await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: temp?.token,
        fields:['currentSectionId', 'sectionId', 'sectionStartTime'],
        values: [temp?.currentSectionId, temp?.currentSectionId, temp?.sectionStartTime]
      }
    );
  };

  return (
    <AppDataContext.Provider
      value={{
        examType,
        setExamType,
        loggedIn,
        setLoggedIn,
        userData,
        setUserData,
        examStarted,
        setExamStarted,
        examStartTime,
        setExamStartTime,
        setExamSectionStartTime,
        config,
        setConfig,
      }}
    >
      {children}
    </AppDataContext.Provider>
  );
};
export { AppDataContext, AppCtxProvider };
